module.exports = __webpack_public_path__ + "img/reset-password-v2-dark.6a5fa812.svg";